import { LedgerOrderData, OrderTables, Table, UserTable } from "../layouts/setting/settingInterface";

export const ledgerTable: Table<LedgerOrderData>[] = [
  { id: "S.No", label: "S.No", numeric: false },
  { id: "orderId", label: "Order ID", numeric: false },
  { id: "status", label: "Order Status", numeric: false },
  { id: "orderDate", label: "Order Date", numeric: false },
  { id: "orderPrice", label: "Order Amount", numeric: true, align: "right" },
  { id: "discount", label: "Discount", numeric: true, align: "right" },
  { id: "finalPrice", label: "Final Amount", numeric: true, align: "right" },
  { id: "res", label: "Received Amount", numeric: true, align: "right" },
  { id: "balance", label: "Remaining Amount", numeric: true, align: "right" },
  { id: "totalOSB", label: "Balance", numeric: true, align: "right" },
];

export const orderHeaderCell: Table<OrderTables>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "Orderdate", label: "Date", numeric: false },
  { id: "Orderid", label: "Order Id", numeric: false },
  { id: "billNumber", label: "Bill No.", numeric: true },
  { id: "CustomerName", label: "Customer Name", numeric: false },
  { id: "CustomerPhoneNo", label: "Phone Number", numeric: false },
  { id: "OrderStatus", label: "Order Status", numeric: true },
];

export const staff_list: Table<UserTable>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "Name", label: "Name", numeric: false },
  { id: "userName", label: "User Name", numeric: false },
  { id: "phoneNumber", label: "Phone Number", numeric: false },
  { id: "Email", label: "Email", numeric: false },
  { id: "doj", label: "Date of Joining", numeric: false },
  { id: "dol", label: "Date of Leaving", numeric: false },
  { id: "status", label: "Status", numeric: false },
  { id: "workingBranch", label: "Branch", numeric: false },
  { id: "role", label: "Role", numeric: false },
];
